__turbopack_context__.v({
  "closeButton": "errorModal-module-scss-module__MAeLXq__closeButton",
  "errorBottom": "errorModal-module-scss-module__MAeLXq__errorBottom",
  "errorBottomItem": "errorModal-module-scss-module__MAeLXq__errorBottomItem",
  "errorBottomItemText": "errorModal-module-scss-module__MAeLXq__errorBottomItemText",
  "errorBottomItemTitle": "errorModal-module-scss-module__MAeLXq__errorBottomItemTitle",
  "logoContainer": "errorModal-module-scss-module__MAeLXq__logoContainer",
  "message": "errorModal-module-scss-module__MAeLXq__message",
  "modalContent": "errorModal-module-scss-module__MAeLXq__modalContent",
  "modalOverlay": "errorModal-module-scss-module__MAeLXq__modalOverlay",
  "title": "errorModal-module-scss-module__MAeLXq__title",
});
